import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useProfiles } from "../profiles/ProfileContext";
import { Button } from "../components/ui/Button";
import { PageHeader } from "../components/Surface";
import { ListRow } from "../components/ListTable";
import { Results, ItemCard } from "../components/Paged";
import { myBids, laneLabel, LOAD_BID_TYPES, type LoadBid } from "../lib/loads";

export function MyBids() {
  const { active } = useProfiles();
  const isBidder = active ? LOAD_BID_TYPES.includes(active.type) : false;
  const [bids, setBids] = useState<LoadBid[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!active || !isBidder) {
      setLoading(false);
      return;
    }
    myBids(active.id).then((r) => setBids(r.bids)).finally(() => setLoading(false));
  }, [active, isBidder]);

  return (
    <div className="grid gap-6">
      <PageHeader
        title="My bids"
        subtitle="Every bid you've placed and its status."
        actions={<Link to="/loads"><Button variant="ghost">Browse loads</Button></Link>}
      />
      {!isBidder ? (
        <p className="text-sm text-muted">Switch to a carrier or owner-operator profile to see your bids.</p>
      ) : loading ? (
        <p className="font-mono text-sm text-muted">Loading…</p>
      ) : (
        <Results
          items={bids}
          perPage={12}
          defaultView="list"
          listColumns={["Load / Shipper", "Status", "Your bid"]}
          gridClass="grid gap-3 sm:grid-cols-2 lg:grid-cols-3"
          empty={<p className="font-mono text-sm text-muted">You haven't bid on any loads yet.</p>}
          renderRow={(b) => (
            <ListRow key={b.id} to={`/loads/${b.load_id}`} title={laneLabel(b.origin ?? "—", b.destination ?? "—")} meta={[b.poster_name, b.load_status ? `load ${b.load_status}` : null].filter(Boolean).join(" · ")} status={b.status} right={`$${b.amount.toLocaleString()}`} />
          )}
          renderCard={(b) => (
            <ItemCard key={b.id} to={`/loads/${b.load_id}`} title={laneLabel(b.origin ?? "—", b.destination ?? "—")} meta={[b.poster_name, b.load_status ? `load ${b.load_status}` : null].filter(Boolean).join(" · ")} status={b.status} right={`Bid $${b.amount.toLocaleString()}`} />
          )}
        />
      )}
    </div>
  );
}
